import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import {Subject} from 'rxjs';
import {User} from "../models";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {ComponentTitleService} from "../services/componentTitle.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardService} from "../services/card.service";
import {Card} from "../models/card";
import {CardLog} from "../models/cardLog";
import {CardLogService} from "../services/cardLog.service";
import {ResourceService} from "../services/resource.service";
import {Resource} from "../models/resource";

@Component({
    templateUrl: './resourcesInUse.component.html',
    styleUrls: ['./resourcesInUse.component.scss']
})
export class ResourcesInUseComponent implements OnDestroy, OnInit {
    id: string;
    user: User;
    card: Card;
    resources: Resource[];
    card9Expanded: boolean = false;
    view: string = 'preview';
    locale: string = 'pl';
    logs: CardLog[];

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private resourceService: ResourceService,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Resources in use');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.resourceService.getAllInUse()
            .pipe(first())
            .subscribe((resources: Resource[]) => {
                this.resources = resources;
            });
    }

    ngOnDestroy(): void {

    }
}
